import type { IIconProps } from '@app/components/Icon/types'
import { IconLeftOutlined } from '@app/components-legacy/Icon/IconAntd'
import { CTAColorV2 } from '@app/styles/consts'
import type React from 'react'
import styled from 'styled-components'

interface IIconLeftAntdProps extends IIconProps {}

const StyledIconLeftOutlined = styled(IconLeftOutlined)`
  svg {
    fill: ${props => props.color ?? CTAColorV2.primary};
    width: ${props => props.size ?? 11}px;
    height: ${props => props.size ?? 11}px;
  }
`

const IconLeftAntd: React.FC<IIconLeftAntdProps> = props => (
  <StyledIconLeftOutlined {...props} />
)

export default IconLeftAntd
